import { useTranslation } from 'react-i18next'

import { Button, ProfileIcon } from '@mercai/clever'

import { CardInfo } from '@/components'
import { ROUTES_ADMIN } from '@/router'

import { CardSupplyOrderSupplierProps } from './card-supply-order-supplier.type'

export const CardSupplyOrderSupplier = ({
  supplier,
  isLoading,
}: CardSupplyOrderSupplierProps) => {
  const { t } = useTranslation('screenSupplyOrderDetail')
  return (
    <CardInfo
      icon={<ProfileIcon />}
      title={t('cardSupplyOrderSupplierTitle')}
      isLoading={isLoading}
      actions={
        <Button
          variant="secondary"
          size="small"
          target="_blank"
          href={`${ROUTES_ADMIN.SUPPLY.SUPPLIERS.SUPPLIERS.SHOW.fullPath(supplier?.uuid || '')}`}
        >
          {t('showButton')}
        </Button>
      }
      items={[
        {
          label: t('cardSupplyOrderSupplierName'),
          value: supplier?.name || '-',
        },
        {
          label: t('cardSupplyOrderSupplierEmail'),
          value: supplier?.email || '-',
        },
        {
          label: t('cardSupplyOrderSupplierPhone'),
          value: supplier?.phone || '-',
        },
      ]}
    />
  )
}
